import { useContext, useEffect } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import useQuery from "../../../../shared/components/hooks/useQuery";
import { PropertyContext } from "../../../../contexts/PropertyContext";

const PropertyDropdown = () => {
  const {
    propertyCode,
    setPropertyCode,
    setPropertyName,
    setPropertyId,
    setClientID,
    setAccessKey,
    setPmsList, 
  } = useContext(PropertyContext);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { data } = useQuery("properties/my");
  const properties = (data as any)?.items || [];

  const defaultProperty = properties.find((p: any) => p.isDefault)?.property;

  useEffect(() => {
    if (!propertyCode && properties.length > 0) {
      const selected = defaultProperty || properties[0].property;

      setPropertyCode(selected.code);
      setPropertyName(selected.name);
      setPropertyId(selected.id);
      setClientID(selected.client?.id || null);
      setAccessKey(selected.client?.authentications?.access_key || null);
      setPmsList(selected.pmsList || []); 
    }
  }, [
    properties,
    propertyCode,
    defaultProperty,
    setPropertyCode,
    setPropertyName,
    setPropertyId,
    setClientID,
    setAccessKey,
    setPmsList,
  ]);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const code = event.target.value;
    setPropertyCode(code);

    const selected = properties.find((p: any) => p.property.code === code)?.property;

    if (selected) {
      setPropertyName(selected.name);
      setPropertyId(selected.id);
      setClientID(selected.client?.id || null);
      setAccessKey(selected.client?.authentications?.access_key || null);
      setPmsList(selected.pmsList || []);
    }
  };

  return (
    <Box
      sx={{
        minWidth: isMobile ? "80px" : 200,
        mr: isMobile ? 2 : 2,
        ml: isMobile ? 2 : 0,
      }}
    >
      <FormControl fullWidth size="small"> 
        <InputLabel id="property-select-label">Property</InputLabel>
        <Select
          labelId="property-select-label"
          id="property-select"
          value={propertyCode}
          label="Property"
          autoWidth={!isMobile}
          onChange={handleChange}
          /* REMOVED MenuProps zIndex OVERRIDES */
          sx={{
            minHeight: 36,
            ".MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              height: "100%",
              fontSize: isMobile ? "0.875rem" : "inherit",
            },
          }}
        >
          {properties.length > 0 ? (
            properties.map((item: any) => (
              <MenuItem
                key={item.property.id}
                value={item.property.code}
                sx={{
                  fontSize: isMobile ? "0.875rem" : "inherit",
                }}
              >
                {item.property.name} ({item.property.code})
                {item.isDefault && " - Default"}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>No properties found</MenuItem>
          )}
        </Select>
      </FormControl>
    </Box>
  );
};

export default PropertyDropdown;